import { TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import AirlinesInput from '../../components/form/AirlinesInput'
import { updateAirlineCommission } from '../../controllers/settings/airlineCommission/updateAirlineCommission';
import { createAirlineCommission } from '../../controllers/settings/airlineCommission/createAirlineCommission';
import { useDispatch } from 'react-redux';
import { setAlertMsg } from '../../redux/reducers/modal/snackBarSlice';

export default function AirlineCommissionForm({data:defData,callback,close}) {
    const [data,setData] = useState();
    const [loadings,setLoadings] = useState({submit: false})

    const dispatch = useDispatch();
    
    useEffect(() => {
        if(defData?.id)
            setData(defData)
    },[defData])
    
    async function handleSubmit(ev) {
        ev?.preventDefault();
        
        const {airlineCode,airlineName,commission,id} = data || {}
        let res = {return: 0, data: null, msg: 'ERROR 0XACFORM'}
        setLoadings({...loadings,submit: true})
        if(defData?.id)
            res = await updateAirlineCommission(id,{airlineCode,airlineName,commission: Number(commission)})
        else
            res = await createAirlineCommission({airlineCode,airlineName,commission: Number(commission)})
        setLoadings({...loadings,submit: false})

        if(res?.return) {
            dispatch(setAlertMsg(['success',defData?.id ? 'Airline Commission Updated' : 'Airline Commission Added']));
            callback && callback()
        } else 
            dispatch(setAlertMsg(['error',res?.msg]));
    }

    console.log(data)
    
  return (
    <form onSubmit={handleSubmit} className='flex flex-col gap-4 bg-secondary p-4'>
        <h3>{!defData?.id ? 'Create' : 'Update'} Airline Commission</h3>
      <AirlinesInput label={'Select Airline'} 
        val={data?.airlineCode||null}
        returnData={(obj) => setData({airlineCode: obj?.id,airlineName: obj?.name})} />
      <TextField label='Commission' value={data?.commission} onChange={(ev) => setData({...data,commission: ev.target.value})} />
      <div className='flex gap-2 justify-between'>
        <button className='btn_outlined' type='button' onClick={() => close && close()}>Cancel</button>
        <button disabled={loadings?.submit} className='btn2'>{loadings?.submit ? 'Please wait' : 'Submit'}</button>
      </div>
    </form>
  )
}
